import cookie from 'js-cookie';
import cookieExists from 'client/javascript/util/cookie_exists';
import Overlay from 'client/javascript/overlay';
import Form from 'client/javascript/lead_form';
import { setupPhoneInput } from 'client/javascript/phone';
import { hideElements, showElements } from 'client/javascript/util/dom_utils';
import { sendLeadFormHeapEvents } from 'client/javascript/form_analytics';
import { submitLead } from 'client/javascript/submit_lead';
import { trackInteraction } from 'client/javascript/analytics';
import { sendBucketEvent } from 'client/javascript/heap';

const SELECTORS = {
  additionalFields: '.marketing-assets-more',
  cta: '#marketingAssetsCta',
  form: '#marketingAssetsForm',
  nameField: '#marketingAssetsFullName',
  phoneField: '#marketingAssetsPhone',
  contactYesRadio: '#marketingAssetsContactYes',
  contactNoRadio: '#marketingAssetsContactNo',
  close: '.close-overlay'
};


const PREVIOUSLY_SUBMITTED_FORM_COOKIE_NAME = '__we_marketing_assets_cookie';

let ctaEl;
let formEl;
let overlay;

export function setupMarketingAssets() {
  ctaEl = document.querySelector(SELECTORS.cta);
  formEl = document.querySelector(SELECTORS.form);

  const hasBrochure = !!ctaEl;
  if (!hasBrochure) return;

  const isGated = !!formEl;
  if (isGated) {
    setupForm();
  } else {
    setupDownloadCta();
  }

  enableCtaEl();
  sendBucketEvent('marketing_assets', { customLabel: 'Downloadable Assets' });
}

function setupForm() {
  overlay = new Overlay('marketingAssetsOverlay', { focusTrap: { initialFocus: SELECTORS.nameField } });
  overlay.addContent(formEl);
  showElements(formEl);

  const phoneEl = document.querySelector(SELECTORS.phoneField);
  setupPhoneInput(phoneEl);

  // this selector is used to prevent validating hidden fields
  const visibleFormElementsSelector =
    '.ray-form-item:not(.hidden) input, .ray-form-item:not(.hidden) select, .ray-form-item:not(.hidden) textarea';
  new Form(formEl, handleOnSubmit, { visibleFormElementsSelector }); // eslint-disable-line no-new

  setupEventListeners();
}

function setupEventListeners() {
  const contactYesRadio = document.querySelector(SELECTORS.contactYesRadio);
  const contactNoRadio = document.querySelector(SELECTORS.contactNoRadio);
  const closeButtons = formEl.querySelectorAll(SELECTORS.close);

  ctaEl.addEventListener('click', () => downloadOrOpenOverlay());
  contactYesRadio.addEventListener('click', () => showElements(SELECTORS.additionalFields));
  contactNoRadio.addEventListener('click', () => hideElements(SELECTORS.additionalFields));
  closeButtons.forEach(closeButton => {
    closeButton.addEventListener('click', () => overlay.close());
  });
}

function setupDownloadCta() {
  ctaEl.addEventListener('click', () => downloadFile());
}

function downloadOrOpenOverlay() {
  const didSubmitPreviously = cookieExists(PREVIOUSLY_SUBMITTED_FORM_COOKIE_NAME);
  if (didSubmitPreviously) {
    downloadFile();
  } else {
    overlay.open();
  }
}

export function getLeadSourceDetails(values) {
  const leadSourceDetail = values.is_broker === 'yes' ? 'Building Brochure [Broker]' : 'Building Brochure';
  const leadSourceSubtype = values.wants_to_be_contacted === 'yes' ? 'Consultation - Building Interest' : 'Gated Asset';

  return { leadSourceDetail, leadSourceSubtype };
}

async function handleOnSubmit(event, values) {
  const { leadSourceDetail, leadSourceSubtype } = getLeadSourceDetails(values);

  await submitLead(
    {
      ...values,
      submission_type: 'lead',
      lead_source_subtype: leadSourceSubtype
    },
    leadSourceDetail
  );
  sendLeadFormHeapEvents(values, leadSourceDetail, leadSourceSubtype);
  downloadFile();
  setDidSubmitCookie();
  overlay.close();
}

function setDidSubmitCookie() {
  cookie.set(PREVIOUSLY_SUBMITTED_FORM_COOKIE_NAME, true, {
    expires: 30, // days
    sameSite: 'lax',
    path: '/'
  });
}

function downloadFile() {
  const url = ctaEl.dataset.marketingAssetUrl;
  window.open(url);
  trackInteraction({ label: 'Successfully Downloaded Assets' });
}

function enableCtaEl() {
  ctaEl.classList.remove('js-disabled');
}
